var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('keep-alive',{attrs:{"max":2,"include":"ProductList,StoreList"}},[_c('router-view',{key:_vm.key,staticStyle:{"min-height":"calc(100vh - 96px)"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }